import { call, put, takeLatest } from 'redux-saga/effects';

import { messages } from '../../services/API';
import { actionTypes, requestFailure, requestSuccess } from './actions';

function* getData() {
  const response = yield call(messages);
  yield put(response.isOk ? requestSuccess(response.data) : requestFailure(response.error));
}

export default function* messagesSaga() {
  yield takeLatest(actionTypes.REQUEST_START, getData);
  yield takeLatest(actionTypes.REQUEST_START_SKIP_LOADING, getData);
}
